import React, { useState } from "react";

const Page4 = () => {
  const steps = [
    { title: "Avaliação de Riscos", content: "Identificar e avaliar riscos antes de qualquer mudança planejada." },
    { title: "Planejamento e Aprovação", content: "Planejar, aprovar e implementar mudanças por meio de um processo estruturado, garantindo que todas as etapas sejam seguidas e documentadas." },
    { title: "Comunicação e Treinamento", content: "Informar e treinar as pessoas afetadas antes da implementação da mudança." },
    { title: "Atualização de Documentação", content: "Atualizar toda a documentação impactada pela mudança." },
    { title: "Conformidade Legal e Interna", content: "Garantir que as mudanças estejam em conformidade com normas regulatórias e políticas internas, minimizando riscos legais e de segurança." } 
  ];

  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <div className="moc-page">
      {/* ESQUERDA */}
      <div className="moc-left"  style={{paddingTop: '160px'}}>
        {steps.map((step, index) => (
          <div
            key={index}
            className={`moc-item ${selectedIndex === index ? "active" : ""}`}
            onClick={() => setSelectedIndex(index)}
          >
            <div className="moc-number">{index + 1}</div>
            <div className="moc-title">{step.title}</div>
            <div className="moc-plus">+</div>
          </div>
        ))}
      </div>

      {/* DIREITA */}
      <div className="moc-right"  style={{paddingTop: '160px'}}>
        <h2>
          {selectedIndex + 1}. {steps[selectedIndex].title}
        </h2>
        <p>{steps[selectedIndex].content}</p>
      </div>

      <style>{`

        .container{
          width: 100% !important;
        }


        /* ROOT DA PÁGINA */
        .moc-page {
          display: flex;
          height: 100%;
          overflow: hidden;
        }

        /* COLUNA ESQUERDA */
        .moc-left {
          width: 50%;
          background: #f1f5f9;
          padding: 30px;
          box-sizing: border-box;

          display: flex;
          flex-direction: column;
          gap: 10px;

          overflow-y: auto;
        }

        /* COLUNA DIREITA */
        .moc-right {
          width: 50%;
          background: #4592C5;
          color: white;
          padding: 40px;
          box-sizing: border-box;

          overflow-y: auto;
        }

        /* ITEM */
        .moc-item {
          display: flex;
          align-items: center;
          background: #d9e2ec;
          border-radius: 25px;
          padding: 12px 15px;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .moc-item:hover {
          background: #cbd5e1;
        }

        .moc-item.active {
          background: #93c5fd;
        }

        .moc-number {
          background: #3b82f6;
          color: white;
          border-radius: 50%;
          width: 30px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 10px;
          font-weight: bold;
        }

        .moc-title {
          flex: 1;
          font-size: 14px;
        }

        .moc-plus {
          font-size: 18px;
          font-weight: bold;
          color: #3b82f6;
        }

        /* TEXTO DIREITA */
        .moc-right h2 {
          margin-bottom: 20px;
        }

        .moc-right p {
          white-space: pre-line;
          line-height: 1.6;
        }

        /* MOBILE */
        @media (max-width: 768px) {
          .moc-page {
            flex-direction: column;
            /* height: calc(100vh - 80px);*/
          }

          .moc-left {
            width: 100%;
            height: 40%;
            padding: 20px;
          }

          .moc-right {
            width: 100%;
            height: 60%;
            padding: 20px;
          }
        }
      `}</style>
    </div>
  );
};

export default Page4;